'use client'
import React from 'react';
import {Header} from "@/src/features/header/ui/Header";
import CompetitionList from "@/src/widgets/competition-list/ui/CompetitionList";
import requireAuth from "@/src/shared/hocs/requireAuth";

function Page() {
    return (
        <div>
            <Header text="Соревнования" />
            <div className="p-4 pt-0">
                <CompetitionList path='/panel/competitions/' />
            </div>
        </div>
    );
}

export default requireAuth(Page);